var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24658",
    "data-name": "Path 24658",
    d: "M785.5-1430a67.5,67.5,0,0,0,67.5-67.5,67.5,67.5,0,0,0-67.5-67.5,67.5,67.5,0,0,0-67.5,67.5A67.5,67.5,0,0,0,785.5-1430Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24657",
    "data-name": "Path 24657",
    d: "M0-1258H1920v-342H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24661",
    "data-name": "Path 24661",
    d: "M767.755-1513.886h.106q10.443.457,20.894.659c.407,0,.949,0,1.222.029a1.941,1.941,0,0,1,.709.21,1.869,1.869,0,0,1,.912,1.116,2.718,2.718,0,0,1,.069.363v1.821l-.02,2.64v10.616a1.5,1.5,0,0,0,.446,1.053,1.463,1.463,0,0,0,1.053.422l10.475-.132a42.121,42.121,0,0,0-.582,7v1.529a2.254,2.254,0,0,1-.407,1.384,2.335,2.335,0,0,1-1.018.824,2.271,2.271,0,0,1-.342.111l-.24.045a6.313,6.313,0,0,0-1.768-3.543,6.073,6.073,0,0,0-4.374-1.771,5.879,5.879,0,0,0-4.179,1.841,5.692,5.692,0,0,0-1.515,3.432,6.556,6.556,0,0,0-4.48-.251,6.3,6.3,0,0,0-1.739-3.251,6.073,6.073,0,0,0-4.374-1.771,5.88,5.88,0,0,0-4.179,1.841,5.69,5.69,0,0,0-1.523,3.531,5.267,5.267,0,0,1-1.523-.519,2.814,2.814,0,0,1-.953-.993,2.75,2.75,0,0,1-.269-.614,1.783,1.783,0,0,1-.086-.387l-.09-.622a16.526,16.526,0,0,0-.591-2.472h0a1.653,1.653,0,0,0-.721-.09,1.637,1.637,0,0,0-.721.09h0a16.621,16.621,0,0,0-.595,2.472l-.085.618a4.3,4.3,0,0,0,0,.857,4.162,4.162,0,0,0,3.4,3.666,3.6,3.6,0,0,0,1.572-.07c.216-.054.432-.124.648-.189a5.693,5.693,0,0,0,1.564,3.588,5.886,5.886,0,0,0,4.211,1.8,6.075,6.075,0,0,0,4.358-1.817,6.3,6.3,0,0,0,1.7-3.213,6.538,6.538,0,0,0,4.48-.243,5.716,5.716,0,0,0,1.556,3.473,5.886,5.886,0,0,0,4.211,1.8,6.076,6.076,0,0,0,4.358-1.817,6.3,6.3,0,0,0,1.731-3.51,3.618,3.618,0,0,0,.957.062,4.177,4.177,0,0,0,2.513-1.067,4.455,4.455,0,0,0,1.4-2.5,4.948,4.948,0,0,0,.081-.734v-1.536a42.132,42.132,0,0,0-.591-7.325,1.318,1.318,0,0,0,.485-1.038l-.114-5.129a9.916,9.916,0,0,0-.35-2.859,7.554,7.554,0,0,0-6.423-5.38,22.554,22.554,0,0,0-2.652.029l-1.747.074v-1.306a7,7,0,0,0-.045-.823,4.7,4.7,0,0,0-2.672-3.675,4.525,4.525,0,0,0-1.808-.412h-1.364q-10.492.181-20.967.647a.7.7,0,0,0-.7.708.7.7,0,0,0,.7.709Zm10.814,34.192a4,4,0,0,1-4.228-3.349h0c-.033-.132-.354-.239-.733-.244h0c.379,0,.692-.111.713-.243v-.037a4,4,0,0,1,4.293-3.332,3.609,3.609,0,0,1,3.249,3.626,3.608,3.608,0,0,1-3.281,3.595Zm16.292,0a4,4,0,0,1-4.228-3.349h0c-.033-.132-.354-.239-.733-.244h0c.379,0,.692-.111.713-.243v-.037a4,4,0,0,1,4.293-3.332,3.609,3.609,0,0,1,3.249,3.626,3.608,3.608,0,0,1-3.281,3.595Zm1.584-28.454a18.671,18.671,0,0,1,2.387.165,5.536,5.536,0,0,1,3.495,2.266,5.518,5.518,0,0,1,.847,1.907,7.959,7.959,0,0,1,.126,2.221l-.081,3.707-8.586-.111v-10.216Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24664",
    "data-name": "Path 24664",
    d: "M767.125-1508.285a15.152,15.152,0,0,0,8.042-.017.856.856,0,0,0,.075-.477.861.861,0,0,0-.075-.478h0a15.148,15.148,0,0,0-8.039,0h0a.96.96,0,0,0-.072.492.956.956,0,0,0,.072.491Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24667",
    "data-name": "Path 24667",
    d: "M767.178-1502.135a45.947,45.947,0,0,0,14.091-.017c.072,0,.132-.219.132-.477s-.06-.469-.132-.478h0a45.977,45.977,0,0,0-14.091,0h0c-.072.017-.128.231-.128.492s.056.474.128.491Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24670",
    "data-name": "Path 24670",
    d: "M775.167-1493.956a.851.851,0,0,0,.075-.476.854.854,0,0,0-.075-.476h0a15.168,15.168,0,0,0-8.039,0h0a.951.951,0,0,0-.072.49.951.951,0,0,0,.072.49h0a15.178,15.178,0,0,0,8.039-.028Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74258",
    "data-name": "Group 74258",
    transform: "translate(-384.039 -4609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49636",
    "data-name": "Group 49636",
    transform: "translate(-333.961 6174)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49635",
    "data-name": "Group 49635",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24656",
    "data-name": "Path 24656",
    d: "M713-1570H858v145H713Z",
    fill: "#76cdd9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49638",
    "data-name": "Group 49638",
    transform: "translate(-333.961 6174)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49637",
    "data-name": "Group 49637",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24659",
    "data-name": "Path 24659",
    d: "M762.05-1520.95H811V-1472H762.05Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49640",
    "data-name": "Group 49640",
    transform: "translate(-333.961 6174)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49639",
    "data-name": "Group 49639",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24662",
    "data-name": "Path 24662",
    d: "M762.05-1514.8h18.2v12.05h-18.2Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49642",
    "data-name": "Group 49642",
    transform: "translate(-333.961 6174)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49641",
    "data-name": "Group 49641",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24665",
    "data-name": "Path 24665",
    d: "M762.05-1508.65H786.4v12.05H762.05Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49644",
    "data-name": "Group 49644",
    transform: "translate(-333.961 6174)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49643",
    "data-name": "Group 49643",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24668",
    "data-name": "Path 24668",
    d: "M762.05-1500.45h18.2v12.05h-18.2Z",
    fill: "#003160"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.996b5f03a4aa8e66fcf0a5cf6282c748.svg";
export { ForwardRef as ReactComponent };